import { render, staticRenderFns } from "./phone-edit.vue?vue&type=template&id=cebd5bac&"
import script from "./phone-edit.vue?vue&type=script&lang=js&"
export * from "./phone-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cebd5bac')) {
      api.createRecord('cebd5bac', component.options)
    } else {
      api.reload('cebd5bac', component.options)
    }
    module.hot.accept("./phone-edit.vue?vue&type=template&id=cebd5bac&", function () {
      api.rerender('cebd5bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/phone-edit.vue"
export default component.exports